export const ROUTER_URL = {
    SHOPS: '/shops',
    SHOPS_ID: ({ shopId }) => `/shops/${shopId}`,
    SHOPS_ID_SERVICES: ({ shopId }) => `/shops/${shopId}/services`,
    SHOPS_ID_BUNDLES: ({ shopId }) => `/shops/${shopId}/bundles`,
    SHOPS_ID_BUNDLES_ID: ({ shopId, bundleId }) => `/shops/${shopId}/bundles/${bundleId}`,
    SHOPS_ID_EVENTS: ({ shopId }) => `/shops/${shopId}/events`,
    SHOPS_ID_EVENTS_ID: ({ shopId, eventId }) => `/shops/${shopId}/events/${eventId}`,
    SHOPS_ID_GROUPS: ({ shopId }) => `/shops/${shopId}/groups`,
    SHOPS_ID_SUBSCRIPTIONS: ({ shopId }) => `/shops/${shopId}/subscriptions`,
    RESERVATIONS: '/reservations',
    RESERVATIONS_HISTORY: '/reservations/history',
    RESERVATIONS_DETAILS_TYPE_ID_NEXT: ({
        reservationType, reservationId, next,
    }) => `/reservations/details/${reservationType}/${reservationId}/${next}`,
    NOTIFICATIONS: '/notifications',
    NOTIFICATIONS_PROMOTION_ID: ({ promotionId }) => `/notifications/promotions/${promotionId}`,
    PROFILE: '/profile',
    PROFILE_LOYALTY: '/profile/loyalty',
    PROFILE_SETTINGS: '/profile/settings',
    PROFILE_ACCOUNT: '/profile/account',
    PROFILE_ACCOUNT_PASSWORD: '/profile/account/password',
    SIGN_IN_RESERVATIONS: '/signin/reservations',
    SIGN_IN_PROFILE: '/signin/profile',

    // TODO: redo to /shops/id/category/id
    BUNDLE_ID: ({ bundleId }) => `/bundle/${bundleId}`,
    EVENT_ID: ({ eventId }) => `/event/${eventId}`,
    BOOK: '/book',
    BOOK_CONFIRM_GROUP: '/book/confirm/group',
    BOOK_CONFIRM_SERVICE: '/book/confirm/service',
    BOOK_CONFIRM_BUNDLE: '/book/confirm/bundle',
    BOOK_CONFIRM_EVENT: '/book/confirm/event',
    BOOK_SUCCESS_BUNDLE: '/book/success/bundle',
    BOOK_SUCCESS_PAYMENT: '/book/success/payment',
};
